import DOTENV from '../../env.json';
import DOTENVLOCAL from '../../envLocal.json';
import { sessionService } from 'redux-react-session';
import CoolDown from '../CoolDown';
import { v4 as uuidv4 } from 'uuid';

class Base {

    constructor (token) {

        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*,Access-Control-Allow-Origin ',
            'Authorization': 'Bearer ' + token
        }
        this.fileHeaders = {
            'Accept': 'application/json',
            'Access-Control-Allow-Origin':'*',
            'Authorization': 'Bearer ' + token
        }
        if(window.location.origin.includes('mubit.co')){
            this.baseUrl = DOTENV.ENDPOINT;
        } else {
            this.baseUrl = DOTENVLOCAL.ENDPOINT;
        }

        this.enableCoolDown = false;
        
    }

    updateToken( newToken ){
        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*',
            'Authorization': 'Bearer ' + newToken
        }
        this.fileHeaders = {
            'Accept': 'application/json',
            'Access-Control-Allow-Origin':'*',
            'Authorization': 'Bearer ' + newToken
        }
        console.log('newHeader',this.headers)
    }

    getUrlEndpoint( param = '') {
        return this.baseUrl+this.endpoint+"/"+param
    }

    getUrlEndpointDEV( param = '') {
        return DOTENV.ENDPOINT+this.endpoint+"/"+param
    }


    requestData( data ) {
        return sessionService.loadUser().then( (user) => {
            
            var newData = Object.assign({},data,{ user_id : user.id })
            return JSON.stringify(newData)
        })
    }


    getById( id ) {
        return  fetch(this.getUrlEndpoint("get/"+id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getAll( owner_id ) {
        return  fetch(this.getUrlEndpoint("retrieve/"+owner_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    retrieve( ) {
        return  fetch(this.getUrlEndpoint("retrieve/"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getContracts( orderBy = '' , order = 'ASC', search = '' ) {
        return  fetch(this.getUrlEndpoint("contracts/?orderBy="+orderBy+"&order="+order+"&search="+search),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getPaginated( page = 1, orderBy = '' , order = 'ASC', search = '' ) {
        return  fetch(this.getUrlEndpoint("paginated/?page="+page+"&orderBy="+orderBy+"&order="+order+"&search="+search),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    create( data , setCurrentUser = true) {
        if(this.enableCoolDown){ 
            if(!CoolDown.instance().canPerformRequest(this.getUrlEndpoint("create"))){
                console.error("Request Repetida y se ha cancelado");
                return new Promise( (resolve, reject) => {
                    resolve({ repeated: true })
                })
            }
        }
        var uuid = uuidv4();
        if(setCurrentUser){
            
            CoolDown.instance().registerNewRequest(uuid,this.getUrlEndpoint("create"));
            return  this.requestData(data).then( (sData) => {
                return fetch(this.getUrlEndpoint("create"),{
                    method: 'POST',
                    headers: this.headers,
                    body: sData
                }).then( response => response.json()).then( (response) => {
                    CoolDown.instance().unregisterRequest(uuid)
                    return new Promise( resolve => {
                        resolve(response)
                    })
                } )
            })

        } else {
            CoolDown.instance().registerNewRequest(uuid,this.getUrlEndpoint("create"));
            console.log("DATA TO SEND",data)
            console.log("DATA TO SEND STR",JSON.stringify(data))
            return fetch(this.getUrlEndpoint("create"),{
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify(data)
            }).then( response => response.json()).then( (response) => {
                CoolDown.instance().unregisterRequest(uuid)
                return new Promise( resolve => {
                    resolve(response)
                })
            } )
        }
        
        
        
    }

    updateID( id, data, setCurrentUser = false ) {

        if(setCurrentUser){
            return  this.requestData(data).then( (sData) => {
                return fetch(this.getUrlEndpoint("update/"+id),{
                    method: 'PATCH',
                    headers: this.headers,
                    body: sData
                }).then( response => response.json() )
            })
        } else {
            
                return fetch(this.getUrlEndpoint("update/"+id),{
                    method: 'PATCH',
                    headers: this.headers,
                    body: JSON.stringify(data)
                }).then( response => response.json() )
            
        }


        
    }

    update( data ) {
        return  this.requestData(data).then( (sData) => {
            return fetch(this.getUrlEndpoint("update"),{
                method: 'PATCH',
                headers: this.headers,
                body: sData
            }).then( response => response.json() )
        })
    }

    delete( id ) {
        return  fetch(this.getUrlEndpoint(id),{
            method: 'DELETE',
            headers: this.headers
        }).then( response => response.json() )
    }

}

export default Base;